/**
 * Adminator Admin Template
 * Modern Entry Point - Phase 2 Modernization
 */

// Import the modern application
import './app.js';

// Legacy imports that haven't been modernized yet
// These will be gradually replaced in future iterations
import './datatable';
// import './datepicker'; // REMOVED: Replaced with modern day.js implementation in app.js

// Import Leaflet map for GPS tracking (replaces vector map)
import './leafletMap';
import './dashboard-controls';

// Disable vector map (replaced by Leaflet)
// import './vectorMaps'; // DISABLED: Replaced with Leaflet for GPS tracking

// Note: The following have been modernized and are now handled by app.js:
// - sidebar (now Sidebar component)
// - charts (now ChartComponent using Chart.js instead of jQuery Sparkline)
// - Basic DOM utilities (now DOM utils)

